import http from "./Http";

export default {
    getGerenciaisPivotGrid: function (data) {
        return http.post('./api/financeiro/gerenciais/pivotgrid', data)
    },
    getGerenciaisAnaliticoDataGrid: function (data) {
        return http.post('./api/financeiro/gerenciais/analiticoDataGrid', data)
    },
    getSituacaoEmpresaMestre: function() {
        return http.get("./api/financeiro/gerenciais/situacaoEmpresaMestre");
    },
    postPerfilGerenciais: function (data) {
        return http.post('./api/financeiro/gerenciais/postPerfilGerenciais', data)
    },
    deletePerfilGerenciais: function (handle) {
        return http.post('./api/financeiro/gerenciais/deletePerfilGerenciais/' + handle)
    },
    getPerfilGerenciais: function (handle) {
        return http.get('./api/financeiro/gerenciais/getPerfilGerenciais/' + handle)
    },
    // Handle + nome dos itens de um lookup do Filtro avancado. O perfil grava so os
    // handles; sem o nome o select2 nao tem como repintar a selecao ao carregar o perfil.
    getDescricoesLookup: function (entityName, handles) {
        return http.post('./api/financeiro/gerenciais/descricoesLookup', { entityName: entityName, handles: handles })
    }
}